<template>

    <div class="notes">
        <div class="note">
            <div class="title">
                {{$t('quickStartNotes.fuzzyMatch')}} :
            </div>
            {{$t('quickStartNotes.fuzzyMatchDescription')}}
        </div>
        <div class="note">
            <div class="title">
                {{$t('quickStartNotes.exactMatch')}} :
            </div>
            {{$t('quickStartNotes.exactMatchDescription')}}
        </div>
        <div class="note">
            <div class="title">
                {{$t('quickStartNotes.translatoinProviders')}} :
            </div>
            {{$t('quickStartNotes.translatoinProvidersDescription')}}
        </div>
        <div class="note">
            <div class="title">
                {{$t('quickStartNotes.mergeSegment')}} :
            </div>
            {{$t('quickStartNotes.mergeSegmentDescription')}}
        </div>
    </div>

</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    export default defineComponent({
    })
</script>

<style lang="scss" scoped>

    .notes {
        color: var(--text-color);
        font-size: 16px;
        margin: 20px;

        .note{
            margin-bottom: 20px;
        }

        .title {
            font-weight: 700;
        }

    }

</style>